<template>
  <div class="step-content">
    <span><span class="number-step"># 2 – </span>Accéder à « <strong>Raconter votre journée</strong> »</span>
    <span class="target">
      <img class="screen-tuto" src="../../assets/tuto/screen-1-step-1.png" />
    </span>
    <span
      >pour identifier les gênes visuelles du quotidien de votre client et lui recommander les verres Essilor les mieux
      adaptés.</span
    >
    <img class="screen-tuto" src="../../assets/tuto/screen-2-step-2.png" />
  </div>
</template>

<script>
export default {
  name: 'Step2',
};
</script>

<style scoped>
.step-content {
  padding: 0 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
}
.screen-tuto {
  width: 300px;
}
.number-step {
  font-weight: bolder;
  font-size: 30px;
  color: #0088ec;
}
.target {
  position: relative;
}
strong {
  font-size: 20px;
  color: black;
}
.target::after {
  content: '';
  display: block;
  width: 76px;
  height: 90px;
  border: 2px dashed #0088ec;
  position: absolute;
  top: 45px;
  left: 30px;
}

@media (max-width: 1024px) {
  .screen-tuto {
    width: 270px;
  }
}
</style>
